import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import shouldForwardProp from "@styled-system/should-forward-prop";
import { ja, Locale } from "date-fns/locale";
import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { compose, space, SpaceProps } from "styled-system";

import { Flex } from "..";
import { CustomInput } from "./CustomInput";

const customLocale: Locale = {
  ...ja,
  options: { weekStartsOn: 0, firstWeekContainsDate: 1 },
};
registerLocale("ja", customLocale);

type Props = {
  disabled?: boolean;
  error?: boolean;
  placeholder?: string;
  max?: Date;
  min?: Date;
  value?: Date | null;
  filterDate?: (date: Date) => boolean;
  onChange: (date: Date | null) => void;
} & SpaceProps;

const Root = styled(Flex, {
  shouldForwardProp,
})<SpaceProps>(
  () =>
    css({
      alignItems: "center",
      whiteSpace: "nowrap",
      "& > div": {
        width: "100%",
      },
    }),
  () => compose(space),
);

export const InputDate = React.memo((props: Props) => {
  const {
    disabled,
    value,
    error,
    min,
    max,
    placeholder,
    filterDate,
    onChange,
    ...styles
  } = props;

  return (
    <Root {...styles}>
      <DatePicker
        withPortal
        todayButton="今日"
        locale="ja"
        dateFormat="yyyy年MM月dd日"
        dateFormatCalendar="yyyy年MM月"
        placeholderText={placeholder}
        nextMonthButtonLabel=""
        previousMonthButtonLabel=""
        disabled={disabled}
        selected={value}
        minDate={min}
        maxDate={max}
        filterDate={filterDate}
        customInput={<CustomInput error={error} />}
        onChange={onChange}
      />
    </Root>
  );
});

InputDate.displayName = "InputDate";
